const loginRoundsStorageKey = 'algobridge.loginRounds';
const maximumRedirectRounds = 2;

function readLoginRounds(): number {
  try {
    const parsed = Number(sessionStorage.getItem(loginRoundsStorageKey));
    return Number.isInteger(parsed) && parsed > 0 ? parsed : 0;
  } catch {
    // Storage can be unavailable (private browsing); the guard still works for this page load.
    return 0;
  }
}

function storeLoginRounds(rounds: number): void {
  try {
    if (rounds === 0) sessionStorage.removeItem(loginRoundsStorageKey);
    else sessionStorage.setItem(loginRoundsStorageKey, String(rounds));
  } catch {
    // As above — failing to persist the guard must not break authentication itself.
  }
}

let rounds = readLoginRounds();
let redirectedThisPageLoad = false;
let exhausted = rounds > maximumRedirectRounds;
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) listener();
}

export function noteUnauthorizedRound(): 'redirect' | 'giveUp' {
  if (exhausted || redirectedThisPageLoad) return 'giveUp';

  rounds += 1;
  storeLoginRounds(rounds);

  if (rounds > maximumRedirectRounds) {
    exhausted = true;
    notifyListeners();
    return 'giveUp';
  }

  redirectedThisPageLoad = true;
  return 'redirect';
}

export function noteSuccessfulRequest(): void {
  if (rounds === 0) return;

  rounds = 0;
  storeLoginRounds(rounds);
  if (exhausted) {
    exhausted = false;
    notifyListeners();
  }
}

export function resetLoginLoop(): void {
  const wasExhausted = exhausted;
  rounds = 0;
  redirectedThisPageLoad = false;
  exhausted = false;
  storeLoginRounds(rounds);
  if (wasExhausted) notifyListeners();
}

export function isLoginLoopExhausted(): boolean {
  return exhausted;
}

export function subscribeLoginLoop(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
